<template>
  <div class="col-auto h-100 px-2" @click="selectCategory">
    <div class="row m-0 h-100 align-items-center">
      <div class="col-12 px-3 py-1 cursor" :class="{selected: isSelected}" @click="scrollTo">
        {{categoryItem.cat}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['categoryItem', 'selected'],
  methods: {
    selectCategory () {
      this.$emit('selectCategory', this.categoryItem)
    },
    scrollTo () {
      this.$scrollTo('#' + this.categoryItem.id, 500, { offset: -120 })
    }
    // scrollTo () {
    //   this.$scrollTo('#' + this.categoryItem, 500, { offset: -120 })
    // }
  },
  computed: {
    isSelected () {
      if (this.categoryItem.cat === this.selected) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
  .selected {
    background-color: var(--dark-color);
    color: var(--light-color);
  }
  .dark-mode .selected {
    background-color: var(--light-color);
    color: var(--dark-color);
  }
</style>
